module.exports = __webpack_public_path__ + "media/images/main-bg-p-500-4e3d3a32f5877d27b23f27d02c3fa7c6.jpeg";